import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class PaymentMethodDetailTypeValueObject  {
    _originalTypeClassName = "zERP.BO.PaymentMethodDetailTypeValueObject";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
PaymentMethodDetailTypeValueObject.translate = translateService;
}
this.Id = null;
this.Name = null;
this.Description = null;
this.Code = null;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
Name:any;
Description:any;
Code:any;

static GetClassName(): any{return "PaymentMethodDetailTypeValueObject";
}
static IsCash($this: any): any{return CLMS.Framework.Number.Equal(() => $this.Code, () => 3);
}
static IsCheck($this: any): any{return CLMS.Framework.Number.Equal(() => $this.Code, () => 4);
}
static NeedsBankAccount($this: any): any{return CLMS.Framework.Number.Equal(() => $this.Code, () => 1) || CLMS.Framework.Number.Equal(() => $this.Code, () => 2) || CLMS.Framework.Number.Equal(() => $this.Code, () => 6) || CLMS.Framework.Number.Equal(() => $this.Code, () => 7);
}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}